var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlood({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 12,
    viewBox: "0 0 9 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.5 0L3.9375 0.612394C3.9375 0.612394 2.9775 1.6695 2.01 3.0401C1.0425 4.41069 0 6.05103 0 7.62576C0 8.78588 0.474106 9.89849 1.31802 10.7188C2.16193 11.5391 3.30653 12 4.5 12C5.69347 12 6.83807 11.5391 7.68198 10.7188C8.5259 9.89849 9 8.78588 9 7.62576C9 6.05103 7.9575 4.41069 6.99 3.0401C6.39325 2.19749 5.7498 1.38706 5.0625 0.612394L4.5 0ZM4.5 2.2819C4.83 2.661 5.13 2.97448 5.76 3.86391C6.6675 5.14702 7.5 6.78007 7.5 7.62576C7.5 9.24423 6.165 10.5419 4.5 10.5419C2.835 10.5419 1.5 9.24423 1.5 7.62576C1.5 6.78007 2.3325 5.14702 3.24 3.86391C3.87 2.97448 4.17 2.661 4.5 2.2819Z",
    fill: "#424444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlood);
export default __webpack_public_path__ + "static/media/blood.7a2180b58f891b4998ae602ffdb6f695.svg";
export { ForwardRef as ReactComponent };